
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { PhotoUploadDialog } from "./dialogs/PhotoUploadDialog";

interface UploadPhotoDialogProps {
  userId?: string;
  onPhotoUploaded: () => void;
}

export function UploadPhotoDialog({ userId, onPhotoUploaded }: UploadPhotoDialogProps) {
  const { language } = useLanguage();

  return (
    <PhotoUploadDialog
      userId={userId}
      onPhotoUploaded={onPhotoUploaded}
      trigger={
        <Button className="bg-primary hover:bg-primary/90">
          {t('gallery.uploadNewPhoto', language)}
        </Button>
      }
    />
  );
}
